import { Button, FormInstance } from "antd";
import React from "react";

interface NumericValidatorInputType {
  value: string;
  form: FormInstance;
  fieldName: string;
}

const NumericValidator = ({
  value,
  form,
  fieldName,
}: NumericValidatorInputType) => {
  if (value && /[^0-9,\s]/.test(value)) {
    return Promise.reject(
      <div className="flex justify-start mt-4">
        <Button
          className="bdo-red-button-modal"
          onClick={() => {
            form.setFieldsValue({
              [fieldName]: value
                .replace(/[^0-9,\s]/g, "")
                .replace(/(\d+)\s+(\d+)/g, "$1$2"),
            });
          }}
        >
          Fix all
        </Button>
        <span className="mt-2 ml-2 text-sm">
          Numeric input only! Please use numbers, commas, and spaces.
        </span>
      </div>
    );
  }
  return Promise.resolve();
};

export default NumericValidator;
